// AUTO-GENERATED by `npm run codegen:ui` - do not edit.
namespace $ {

export type easyreels_user_recorder_finishMutationVariables = Exact<{
  input: FinishRecordingInput;
}>;


export type easyreels_user_recorder_finishMutation = { __typename?: 'Mutation', finishRecording: { __typename: 'ErrorPayload', message: string } | { __typename: 'FinishRecordingPayload', recording: { __typename?: 'Recording', id: number, status: RecordingStatus } } };


export function $easyreels_user_recorder_finish(variables: easyreels_user_recorder_finishMutationVariables, opts?: { revalidate?: boolean }): easyreels_user_recorder_finishMutation {
	return $easyreels_gql_user_request(`mutation easyreels_user_recorder_finish(\u0024input: FinishRecordingInput!) {
  finishRecording(input: \u0024input) {
    __typename
    ... on FinishRecordingPayload {
      recording {
        id
        status
      }
    }
    ... on ErrorPayload {
      message
    }
  }
}`, variables, opts) as easyreels_user_recorder_finishMutation
}

}
